import type { AnalysisParagraphResult } from "../../agreement";
import type { CategoryId } from "./tokens";

export function ruleTitle(row: AnalysisParagraphResult): string {
  const a = row.text?.trim();
  if (a) {
    const m = a.match(/^[^.!?]+[.!?]?/);
    const cut = (m ? m[0] : a).trim();
    return cut.length > 100 ? `${cut.slice(0, 97)}…` : cut;
  }
  return `Paragraph #${row.index}`;
}

export function getCategoryForRow(row: AnalysisParagraphResult): CategoryId {
  if (row.compliant) {
    return "compliant";
  }
  if (row.severity === "high") {
    return "needsAttention";
  }
  return "needsReview";
}

export function rowHasApplicableEdits(row: AnalysisParagraphResult): boolean {
  if (row.compliant) {
    return false;
  }
  if (row.wordChanges && row.wordChanges.length > 0) {
    return true;
  }
  return row.suggestion.trim().length > 0;
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export function defaultTabForCategory(category: CategoryId): "analysis" | "suggestion" {
  return category === "compliant" ? "analysis" : "suggestion";
}

export type RowReviewStatus = "pending" | "accepted" | "rejected";

export function getRowReviewStatus(
  row: AnalysisParagraphResult,
  key: string,
  aiRowStatus: Record<string, RowReviewStatus>
): RowReviewStatus {
  const fromState = aiRowStatus[key];
  if (fromState) return fromState;
  const fromRow = row.reviewStatus;
  if (fromRow === "accepted" || fromRow === "rejected") return fromRow;
  return "pending";
}
